<template>
    <DashboardGraph
            barChart="true"
            :color="color"
            :icons="icons"
            :title="title"
            :load_url="load_url">
    </DashboardGraph>
</template>

<script>
    import DashboardGraph from '../../widgets/DashboardGraph';
    export default {
        name: 'QuotesEntered',
        components: {DashboardGraph},
        data() {
            var labels = [];
            for(var i = 8; i <= 17;i++){
                labels[i-8] = 'Hour '+i;
            }
            return {
                icons:labels,
                color: 'rgba(32, 168, 216, .6)',
                title: 'Quotes',
                load_url: '/dashboards/Quotes',
                time_wait: 10000,
            };
        },
    };
</script>

<style scoped>

</style>